<template>
  <div class="d-flex">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol  sm="12" lg="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm @submit.prevent="update()">
                <h3>Đổi mật khẩu tài khoản</h3>
                <p class="text-muted">Nhập mật khẩu hiện tại và mật khẩu mới</p>

                <!-- current password -->
                <CInput
                  placeholder="Mật khẩu hiện tại"
                  type="password"
                  autocomplete="current-password"
                  v-model="info.password"
                  @blur="validate()"
                  v-bind:class="{'is-invalid': errors.password}"
                >
                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <div class="invalid-feedback" v-if="errors.password">{{ errors.password }}</div>

                <!-- new password -->
                <CInput
                  placeholder="Mật khẩu mới"
                  type="password"
                  autocomplete="new-password"
                  v-model="info.new_password"
                  @blur="validate()"
                  v-bind:class="{'is-invalid': errors.new_password}"
                >
                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <div class="invalid-feedback"
                v-if="errors.new_password">{{ errors.new_password }}</div>

                <!-- new password repeat -->
                <CInput
                  placeholder="Nhắc lại mật khẩu mới"
                  type="password"
                  autocomplete="new-password"
                  class="mb-4"
                  v-model="info.new_password_repeat"
                  @blur="validate()"
                  v-bind:class="{'is-invalid': errors.new_password_repeat}"
                >
                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>

                <div class="invalid-feedback"
                v-if="errors.new_password_repeat">{{ errors.new_password_repeat }}</div>

                <CButton type="submit" shape="pill" color="info" block>Đổi</CButton>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: {
        password: '',
        new_password: '',
        new_password_repeat: '',
      },
      info: {
        password: '',
        new_password: '',
        new_password_repeat: '',
      },
    }
  },
  methods: {
    validate() {
      this.errors = {
        password: '',
        new_password: '',
        new_password_repeat: '',
      }
      let isValid = true
      if(!this.info.password) {
        this.errors.password = 'Current password is required!'
        isValid=false
      }
      if(!this.info.new_password) {
        this.errors.new_password = 'New password is required!'
        isValid=false
      } else {
        if(this.info.new_password === this.info.password) {
            this.errors.new_password = 'New password must different current password!'
            isValid=false
        }
      }

      if(this.info.new_password !== this.info.new_password_repeat) {
        this.errors.new_password_repeat = 'Retype password does not match!'
        isValid=false
      }

      return isValid
    },
    update() {
      if(this.validate()){
        this.$swal.fire({
          title: "Đổi mật khẩu?",
          showDenyButton: false,
          showCancelButton: true,  
      }).then((result) => {
          if (result.isConfirmed) {
            this.$request.put('/api/user/password', this.info)
            .then(res=>{
              if(res.data.status == 'success') {
                this.$swal.fire({
                  icon: "success",
                  title: "Đổi mật khẩu",
                  text: "Đổi mật khẩu thành công!",
                  });
                this.$logout()
                return;
              }
              this.$swal.fire({
                icon: "error",
                title: "Đổi mật khẩu",
                text: "Đổi mật khẩu thất bại: " + res.data.status,
                });
            });
          }
        });
      }
    }
  }

}
</script>
